/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'

import { deleteGroup } from './index'

import { calculateQuote } from '../../util'

export default function deleteGroups(args: {
  quote: QuoteDocument
  options: OptionsDocument
  keys: string[]
}): QuoteDocument {
  const { quote, options, keys } = args

  const updatedQuote = keys.reduce(
    (acc: QuoteDocument, key: string) => {
      return deleteGroup({ quote: acc, key, calculate: false, options })
    },
    { ...quote }
  )

  return calculateQuote({ quote: updatedQuote, options })
}
